// extracted by mini-css-extract-plugin
module.exports = {"root":"Input.kaufland_root__1wwOK","checkmark":"Input.kaufland_checkmark__3tZKY","error":"Input.kaufland_error__1d_tS"};